import { type RawQuoteData, type StoryblokEditable } from '@activebrands/core-web/libs/storyblok/storyblok';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';
import { Richtext } from 'storyblok-js-client';

export type QuoteType = {
    author: string;
    component: 'quote';
    id: string;
    quote: Richtext;
    sbEditable?: StoryblokEditable;
    text: Richtext;
};

type TransformQuoteProps = {
    quote: RawQuoteData | RawQuoteData[] | undefined;
};

const transformQuote = ({ quote }: TransformQuoteProps): QuoteType | undefined => {
    if (!quote || (Array.isArray(quote) && !quote?.[0])) {
        return;
    }

    const quoteData = Array.isArray(quote) ? quote[0] : quote;
    const { _uid, _editable, component, quote: text, author } = quoteData;

    return {
        author,
        component,
        id: _uid,
        quote: text,
        sbEditable: transformPreviewEditable(_editable),
        text,
    };
};

export default transformQuote;
